import { getNativeInfo } from "../jsbridge"
import { EUFY_MEGA_APPLICATION_NAME, EUFY_SECURITY_APPLICATION_NAME } from "./constants";
import { getCookie } from './cookie'

type ApiVersionPaths = 'v1' | 'v2' | 'v3';

// v2 v3接口汇总 后期新增接口在此处添加
export const apiVersionConfig: Record<string, any> = {
    // 获取用户信息
    "profile": {
        "v1": '/v1/passport/profile',
        "v2": '/v2/web/passport/profile',
        "v3": '/v3/web/passport/profile'
    },
    // 获取设备列表
    "get_devs_list": {
        "v1": '/v1/app/get_devs_list',
        "v2": '/v2/web/get_devs_list',
        "v3": '/v3/web/get_devs_list'
    },
    // 获取基站列表
    "get_hub_list": {
        "v1": '/v1/app/get_hub_list',
        "v2": '/v2/web/get_hub_list',
        "v3": '/v3/web/get_hub_list'
    },
    // solution 点赞状态
    // 直接从v1升级到了v3
    "set_like": {
        "v1": '/app/cms/article/set_like',
        "v2": '/app/cms/article/set_like',
        "v3": '/v3/app/cms/article/set_like'
      },
}

/**
 * @param url 
 * @returns v1 v2 v3
 * @description 
 * 针对请求url加强兼容性
 * 假设url为 /app/v3/web/get_hub_list  根据url结尾找到对应的key 例如 get_hub_list 然后匹配get_hub_list对象的key 返回v3
 */
export const determineApiVersionFromUrl = async (url: string | undefined): Promise<ApiVersionPaths> => {
    if (!url) {
        return 'v1';
    }
    for (const key in apiVersionConfig) {
        if (apiVersionConfig.hasOwnProperty(key)) {
            const versions = apiVersionConfig[key];
            for (const version in versions) {
                // 说明url是v3接口
                if (url.endsWith(versions[version])) {
                    return await getAppVersionCompatibility() as ApiVersionPaths;
                }
            }
        }
    }
    return 'v1';
};


// 根据app版本号判断使用v2还是v3接口
export const getAppVersionCompatibility = async (): Promise<ApiVersionPaths> => {
    const nativeInfo = await getNativeInfo().catch(() => Promise.resolve(undefined))
    const appName = getCookie('app_name')
    if (nativeInfo?.appName === EUFY_MEGA_APPLICATION_NAME || appName === EUFY_MEGA_APPLICATION_NAME) {
      return 'v3'
    }
    if (!nativeInfo || !nativeInfo.appVersion || !nativeInfo.appName) {
      return 'v1'
    }
    const appVersion = nativeInfo.appVersion.match(/[\d.]+/)?.join('') || ''
    const isSecure = /eufy\ssecurity/i.test(nativeInfo.appName) || appName === EUFY_SECURITY_APPLICATION_NAME
    if (isSecure) {
      if (appVersion >= '4.5.1' && appVersion < '4.8.0') {
        return 'v2'
      } else if (appVersion >= '4.8.0') {
        return 'v3'
      }
    }
    return 'v1'
};


// 返回具体v2 || v3接口地址
export const processVersionPath = async (urlKey: string): Promise<string | undefined> => {
    if (!urlKey) {
        return undefined;
    }
    const version = await getAppVersionCompatibility();
    return apiVersionConfig[urlKey][version];
};

// 判断是否为Mega URL
export function isMegaUrl(url: string): boolean {
    // 正则表达式匹配规则，确保xxx是字母且后缀为us, eu或cn
    const megaUrlPattern = /^https:\/\/app-[a-zA-Z]+-(us|eu|cn)/
    return megaUrlPattern.test(url)
  }

// 从URL中截取指定部分
export function extractBaseUrl(url: string): string {
    // 正则表达式匹配到.eufylife.com之前的部分
    const baseUrlPattern = /^(https?:\/\/[^/]+\.com)/
    const match = url.match(baseUrlPattern)
    return match ? match[1] : ''
  }